<template>
  <div id="about">
    <div class="mr-about">
      <div class="mr-about__inner">
        <div class="mr-about__inner__info">
          <div class="mr-about__inner__info__inner">
            <div class="mr-about__inner__info__top">
              <p>
                STEGI.RADIO is <a href="https://www.onassis.org/" target="_blank">Onassis Stegi’s</a> online radio
                station, broadcasting 24 hours a day, 7 days a week. Based in Athens but looking beyond geographical
                borders and boundaries, STEGI.RADIO focuses on musical and cultural communities and music creation; it
                seeks novel ideas and sounds that reflect the new musical production as well as its historical course,
                creating an ever-expanding network between the cities of the Mediterranean and the rest of the globe.
              </p>
              <p>
                The station curates Onassis Stegi’s musical activities (the festivals <a
                  href="https://www.onassis.org/whats-on/stegi-radio-takeover"
                  target="_blank">TAKEOVER</a> and <a href="https://www.onassis.org/whats-on/borderline-festival-2024"
                                                      target="_blank"> Borderline</a>) and
                reaches out into the city with events, talks, and workshops. At the same time, it continues research
                into the musical and cultural movements of the Mediterranean, traveling across an imaginary archipelago
                that reaches beyond geography and chronology.
              </p>
              <div class="sub-title">
                Send your demos here
                <a href="mailto: info@stegi.radio">info@stegi.radio</a>
              </div>
            </div>
            <div class="mr-about__inner__info__bottom">
              <!-- First Logo Roles -->
              <img src="@/assets/images/logo-onassis-culture.png" alt="Onassis Culture" class="logo-label large" />

              <div class="roles-container">
                <div class="role-group">
                  <span class="role-title">ARTISTIC DIRECTOR</span>
                  <span class="role-value">Afroditi Panagiotakou</span>
                </div>
                <div class="role-group">
                  <span class="role-title">EXECUTIVE DIRECTOR</span>
                  <span class="role-value">Dimitris Theodoropoulos</span>
                </div>
              </div>

              <!-- Second Logo Roles -->
              <img src="@/assets/images/logo-stegi-radio.png" alt="Stegi Radio" class="logo-label small" />

              <div class="roles-container">
                <div class="role-group">
                  <span class="role-title">ARTISTIC DIRECTION</span>
                  <span class="role-value">Voltnoi + Quetempo</span>
                </div>
                <div class="role-group">
                  <span class="role-title">RADIO &amp; PROGRAM MANAGER</span>
                  <span class="role-value">Nikki Georgiou</span>
                </div>
                <div class="role-group">
                  <span class="role-title">CONTENT MANAGER</span>
                  <span class="role-value">Yannis Galiatsos</span>
                </div>
                <div class="role-group">
                  <span class="role-title">STUDIO MANAGER</span>
                  <span class="role-value">Stefanos Konstantinidis – Fabrika Music Studio</span>
                </div>
                <div class="role-group">
                  <span class="role-title">PRODUCER</span>
                  <span class="role-value">Akis Chontasis</span>
                </div>
                <div class="role-group">
                  <span class="role-title">VISUAL COMMUNICATION DESIGN</span>
                  <span class="role-value">Oblique Strategies</span>
                </div>
                <div class="role-group">
                  <span class="role-title">WEB DEVELOPMENT</span>
                  <span class="role-value">GENDY</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mr-about__inner__image">
          <picture>
            <img :src="aboutImage" alt="MovementRadio About"/>
          </picture>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import aboutImage from '@/assets/images/about.jpg';
import onassisImage from '@/assets/logos/onassis-stegi-official-black-inline.svg';
import saeImage from '@/assets/logos/sae.svg';

export default {
  name: 'About',
  data: () => ({
    aboutImage: aboutImage,
    onassisImage: onassisImage,
    saeImage: saeImage
  })
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/pages/_about.scss';
</style>
